import type { User } from '@supabase/supabase-js';
import { isValidEmail, normalizeEmail } from './emailUtils';

/** Microsoft / Azure often puts the address in metadata, not user.email. */
export function resolveAuthEmail(user: User | null | undefined): string | null {
  if (!user) return null;

  if (user.email && isValidEmail(user.email)) {
    return normalizeEmail(user.email);
  }

  const meta = user.user_metadata ?? {};
  const candidates = [
    meta.email,
    meta.preferred_username,
    meta.upn,
    meta.unique_name,
    meta.mail,
  ];

  for (const value of candidates) {
    if (typeof value === 'string' && isValidEmail(value)) {
      return normalizeEmail(value);
    }
  }

  for (const identity of user.identities ?? []) {
    const data = identity.identity_data ?? {};
    const fromId = data.email ?? data.preferred_username ?? data.upn;
    if (typeof fromId === 'string' && isValidEmail(fromId)) {
      return normalizeEmail(fromId);
    }
  }

  return null;
}
